<template>
  <div v-if="editMode || dgRowInEditMode[gridId + '.' + rowKey]">
    <div class="data-grid__userSelectWrapper">
      <multiselect
        v-model="users"
        :options="usersSelect"
        track-by="value"
        label="text"
        :searchable="true"
        selectLabel
        selectedLabel
        tagPlaceholder
        placeholder
        deselectLabel
        :allow-empty="true"
        :multiple="true"
        @select="save"
        @remove="save"
        :disabled="controlInfo.readonly"
        openDirection="bottom"
        ref="select"
        @open="adjustDropdown"
        @close="releaseDropdown"
      />
    </div>
  </div>
  <div v-else>
    <div v-if="cellDisplayVal">
      <b-badge
        v-for="(user, key) in cellDisplayVal"
        :key="key"
        pill
        variant="primary"
        style="margin-right: 3px;"
      >{{ user }}</b-badge>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
// services
import db from '@/services/db'

export default {
  props: [
    'rowKey',
    'cellKey',
    'cellVal',
    'cellDisplayVal',
    'options',
    'gridId',
    'widgetKey',
    'display',
    'editMode',
    'controlInfo',
  ],
  data() {
    return {
      users: [],
    }
  },
  watch: {
    cellVal() {
      this.setSelectedUsers()
    },
  },
  computed: {
    ...mapState(['userList', 'dgRowInEditMode']),
    usersSelect() {
      const userList = []

      for (let user of this.userList) {
        userList.push({ text: user.email || user.uid, value: user.uid })
      }

      return userList
    },
  },
  methods: {
    setSelectedUsers() {
      const dbUsers = this.cellVal ? this.cellVal.split(',') : []
      const users = []

      for (let user of dbUsers) {
        const idx = _.findIndex(this.usersSelect, { value: user })
        users.push(this.usersSelect[idx])
      }

      this.users = users
    },
    save() {
      this.$nextTick(() => {
        const users = []

        for (let user of this.users) {
          users.push(user.value)
        }

        if (
          this.options.isReactive ||
          typeof this.options.isReactive === 'undefined'
        ) {
          const data = {
            options: this.options,
            rowKey: this.rowKey,
            cellKey: this.cellKey,
            value: users.join(',') || null,
          }

          db.dataGrid.data.saveCellVal(data)
        } else {
          const rowInst = this.$instByClass(this, 'data-grid__row')

          rowInst.rowData[this.cellKey] = users.join(',') || null
        }
      })
    },
    adjustDropdown() {
      this.$multiselect_adjustDropdown.bind(this)()
    },
    releaseDropdown() {
      this.$multiselect_releaseDropdown.bind(this)()
    },
  },
  created() {
    this.setSelectedUsers()
  },
  beforeDestroy() {
    this.users = null
  },
}
</script>

<style lang="scss">
.data-grid .data-grid {
  &__cell._user {
    min-width: 250px;
    padding: 0;
  }
}
</style>
